import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LoginModel } from '../models/login.model';
import { LoginRepository } from '../repositories/login.repository';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private loginRepository: LoginRepository
  ) { }

  public loginCostumer(loginForm: LoginModel): Observable<LoginModel> {
    return this.loginRepository.loginCostumer(loginForm);
  }

  public loginProducer(loginForm: any): Observable<any> {
    return this.loginRepository.loginProducer(loginForm);
  }

}
